import { render, staticRenderFns } from "./HeaderTag.vue?vue&type=template&id=04bd8cba&scoped=true&"
import script from "./HeaderTag.vue?vue&type=script&lang=js&"
export * from "./HeaderTag.vue?vue&type=script&lang=js&"
import style0 from "./HeaderTag.vue?vue&type=style&index=0&id=04bd8cba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bd8cba",
  null
  
)

export default component.exports